module.exports = __webpack_public_path__ + "static/media/jobskills_bakgrundsbild_ar.42ec61d5.jpg";